import React from 'react';

const AplicacionContext = React.createContext();

export default AplicacionContext;